import { render, staticRenderFns } from "./documento_receita.vue?vue&type=template&id=04f4afc2&scoped=true&"
import script from "./documento_receita.vue?vue&type=script&lang=js&"
export * from "./documento_receita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4afc2",
  null
  
)

export default component.exports